'use es6';

export default (domain => {
  if (domain.indexOf('http') === -1) {
    domain = `http://${domain}`;
  }
  const a = document.createElement('a');
  a.href = domain;
  return a.hostname;
});